var map = {
	".": 36,
	"./": 36,
	"./constants": 128,
	"./constants.js": 128,
	"./index": 36,
	"./index.js": 36,
	"./lib": 79,
	"./lib/": 79,
	"./lib/distanceInWord": 223,
	"./lib/distanceInWord.js": 223,
	"./lib/distanceInWordStrict": 225,
	"./lib/distanceInWordStrict.js": 225,
	"./lib/distanceInWordToNow": 226,
	"./lib/distanceInWordToNow.js": 226,
	"./lib/formatDate": 227,
	"./lib/formatDate.js": 227,
	"./lib/index": 79,
	"./lib/index.js": 79,
	"./locale": 30,
	"./locale.js": 30,
	"./readme.md": 1053,
	"./test/TimeZone.test": 655,
	"./test/TimeZone.test.js": 655,
	"./utils/stringToDateObject": 190,
	"./utils/stringToDateObject.js": 190
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1049;